import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { useSite } from "@/lib/site";
import { ZONE_NAMES, TYPES, FURNISHED } from "@/lib/constants";

const cls = "w-full bg-transparent text-sm font-medium text-slate-900 outline-none py-1";

export function SearchField({ label, children }) {
  return (
    <label className="flex flex-col px-4 py-2.5 border-b sm:border-b-0 lg:border-r border-slate-100 last:border-0 min-w-0">
      <span className="text-[11px] uppercase tracking-wider text-slate-400 font-semibold">{label}</span>
      {children}
    </label>
  );
}

export default function SearchBar({ initial = {}, compact = false }) {
  const { t } = useSite();
  const nav = useNavigate();
  const [f, setF] = useState({ zone: "", type: "", bedrooms: "", min_price: "", max_price: "", furnished: "", ...initial });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = (e) => {
    e.preventDefault();
    const qs = new URLSearchParams(Object.entries(f).filter(([, v]) => v)).toString();
    nav(`/propiedades${qs ? `?${qs}` : ""}`);
  };
  return (
    <form onSubmit={submit} className={`bg-white rounded-2xl ${compact ? "border border-slate-200" : "shadow-2xl shadow-black/20"} grid grid-cols-2 lg:grid-cols-[1.3fr_1fr_0.8fr_0.8fr_0.8fr_1fr_auto] items-center p-2 gap-0`} data-testid="search-form">
      <SearchField label={t("zone")}>
        <select className={cls} value={f.zone} onChange={set("zone")} data-testid="search-zone-select">
          <option value="">{t("any")}</option>{ZONE_NAMES.map((z) => <option key={z}>{z}</option>)}
        </select>
      </SearchField>
      <SearchField label={t("type")}>
        <select className={cls} value={f.type} onChange={set("type")} data-testid="search-type-select">
          <option value="">{t("any")}</option>{TYPES.map((z) => <option key={z}>{z}</option>)}
        </select>
      </SearchField>
      <SearchField label={t("bedrooms")}>
        <select className={cls} value={f.bedrooms} onChange={set("bedrooms")} data-testid="search-bedrooms-select">
          <option value="">{t("any")}</option>{[1, 2, 3, 4, 5].map((n) => <option key={n} value={n}>{n}+</option>)}
        </select>
      </SearchField>
      <SearchField label={t("minPrice")}>
        <input type="number" min="0" placeholder="US$" className={cls} value={f.min_price} onChange={set("min_price")} data-testid="search-min-price" />
      </SearchField>
      <SearchField label={t("maxPrice")}>
        <input type="number" min="0" placeholder="US$" className={cls} value={f.max_price} onChange={set("max_price")} data-testid="search-max-price" />
      </SearchField>
      <SearchField label={t("furnished")}>
        <select className={cls} value={f.furnished} onChange={set("furnished")} data-testid="search-furnished-select">
          <option value="">{t("any")}</option>{FURNISHED.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      </SearchField>
      <button type="submit" className="col-span-2 lg:col-span-1 m-1 flex items-center justify-center gap-2 rounded-xl bg-[#FF3333] hover:bg-[#E62E2E] text-white font-semibold px-6 py-4 transition-colors" data-testid="search-submit-button">
        <Search size={18} />{t("search")}
      </button>
    </form>
  );
}
